import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import logo from "../assets/logo.png";

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<div 
					className="MainBodySection bg-surface"
					style={{
						paddingBottom: "50px",
						paddingTop: "50px"
					}}
				>
					<div className="container">
						<div className="row text-center">
							<div className="col-md-12">
								<img src={logo} height={200} />
								<h3 className="main-section-title my-0">Boston Unique Services Limited</h3>
							</div>
							<div 
								className="col-md-9 m-auto p-3"
								style={{
									textAlign: "justify"
								}}
							>
								<h5>
									Boston Unique Services Limited is a premium systems company that was founded in the year 2010 and incorporated in the year 2023 in the United Republic of Tanzania. For the last 12 years, the foudners and key stakeholders of Boston Unique Services were working with ENCAPSULATED EAST AFRICA LIMITED,  a world-class company incorporated in the Republic of Kenya.
									<br />
									<br />
									The stakeholders of Encapsulated East Africa Limited and Boston Unique Services covenanted to extend services to the United Republic of Tanzania in an outfit of Boston Unique services.
									<br />
									<br />
									The company has been formed by a group of professionals having vivid experience and wide exposure in Information Technology and business development. People involved here are young qualified business graduates and qualified engineers from the renowned universities across the region.
									<br />
									<br />
									 The resource personnel working in the company have been consistently providing reliable support services and consultancy to a wide variety of corporate houses either in the capacity of executive or as business partner or consultant. Bottom line of the company philosophy is building a long-term business partnership with its clients where interpersonal relationship, reliability, assured quality and target oriented modern technology are the major building blocks.
									 <br />
									 <br />
									 We want to establish ourselves as the best choice in Computing and Information Technology Services, Consultancy and Development by offering the full spectrum of services.
								</h5>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}